import React, { useEffect, useState } from "react";
import ILogin_Message_Detail from "../../../models/ILogin_Message_Detail";
import moment from "moment-timezone";
import "./LoginMessage.scss";

type LoginMessageProps = {
    loginMessageDetail?: ILogin_Message_Detail;
    showPreviewBox: boolean;
};

export const LoginMessage = (props: LoginMessageProps) => {
    const isActiveLoginMessage = (): boolean => {
        if (props.loginMessageDetail) {
            const today = moment();

            const beginsAt = moment(props.loginMessageDetail.begins_at);
            const expiresAt = moment(props.loginMessageDetail.expires_at);

            return today.isBetween(beginsAt, expiresAt);
        } else {
            return false;
        }
    };

    const getVisibility = (): boolean => {
        if (props.loginMessageDetail) {
            if (props.showPreviewBox) {
                return true;
            } else {
                if (!isActiveLoginMessage()) {
                    return false;
                } else {
                    return true;
                }
            }
        } else {
            return false;
        }
    };

    const [visible] = useState(getVisibility());
    // Derive from props so live edits (e.g. the color picker in the supplier
    // profile preview) re-render with the new color instead of being frozen at
    // mount.
    const selectedColor = props.loginMessageDetail?.color || "#FFFFFF";
    const [isMessageHidden, setIsMessageHidden] = useState(!props.showPreviewBox);

    useEffect(() => {
        // validate the date is active
        if (props.loginMessageDetail) {
            if (!props.showPreviewBox) {
                const _isMessageHidden = hasMessageBeenDismissed();
                setIsMessageHidden(_isMessageHidden);
            }
        }
    }, []);

    const hideMessage = () => {
        setMessageDismissed();

        setIsMessageHidden(true);
    };

    const viewMessage = () => {
        setIsMessageHidden(false);
    };

    const setMessageDismissed = (): void => {
        if (props.loginMessageDetail) {
            const encodedLoginMessage = btoa(JSON.stringify(props.loginMessageDetail));
            localStorage.setItem("loginSupplierMessage", encodedLoginMessage);
        }
    };

    const hasMessageBeenDismissed = (): boolean => {
        if (props.loginMessageDetail) {
            const encodedLoginMessage = btoa(JSON.stringify(props.loginMessageDetail));
            const loginMessage = localStorage.getItem("loginSupplierMessage");

            const isDismissed = (loginMessage && loginMessage === encodedLoginMessage) || false;

            console.log("hasMessageBeenDismissed: ", isDismissed);

            return isDismissed;
        } else {
            return false;
        }
    };

    return visible ? (
        <div>
            <div
                className={"LoginMessage position-relative dashboard-widget " + (isMessageHidden ? "d-none" : "")}
                style={{ "--login-message-accent": selectedColor } as React.CSSProperties}>
                <button type="button" className={"LoginMessage__close"} aria-label="Dismiss message" onClick={hideMessage}>
                    <i className={"fa fa-times"}></i>
                </button>
                <div className={"LoginMessage__body"}>
                    {props.loginMessageDetail?.icon ? <i className={props.loginMessageDetail.icon + " LoginMessage__icon"}></i> : null}
                    <div className={"LoginMessage__content"}>
                        {props.loginMessageDetail?.title ? (
                            <h3 className={"LoginMessage__title"}>{props.loginMessageDetail.title}</h3>
                        ) : null}
                        <div
                            className={"LoginMessage__detail"}
                            dangerouslySetInnerHTML={{ __html: props.loginMessageDetail?.detail || "" }}></div>
                    </div>
                </div>
            </div>

            <div className={"LoginMessage__collapsed " + (isMessageHidden ? "" : "d-none")}>
                <button type="button" className={"LoginMessage__show"} onClick={viewMessage}>
                    <i className={"fa fa-eye"}></i>
                    <span>Show Message</span>
                </button>
            </div>
        </div>
    ) : null;
};
